const SUMMARY = [
    {
        sectionID: 'summary',
        sectionName: 'Application Summary',
        fieldList: [
            {
                id: 'application-name',
                apiID: '',
                label: 'Application Name',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'title',
                apiID: 'Title',
                label: 'Title',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'id',
                apiID: '',
                label: 'ID',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'status',
                apiID: '',
                label: 'Status',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'date-submission',
                apiID: '',
                label: 'Date of submission',
                type: 'text',
                rule: { required: true },
                span: 4
            }
        ]
    }
];

export const SUMMARY_LICENCE = [
    {
        sectionID: 'summary',
        sectionName: 'Licence Summary',
        fieldList: [
            {
                id: 'transactionType',
                apiID: '',
                label: 'Application Type',
                type: 'pill',
                rule: { required: true },
                span: 4
            },
            {
                id: 'application-name',
                apiID: '',
                label: 'Licence Name',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'application-number',
                apiID: '',
                label: 'Application Number',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'application-businessStatus',
                apiID: '',
                label: 'Status',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'application-submission',
                apiID: '',
                label: 'Date of Submission',
                type: 'text',
                rule: { required: true },
                span: 4
            }
        ]
    }
];

export const SUMMARY_LICENCE_TAB = [
    {
        sectionID: 'summary',
        sectionName: 'Licence Summary',
        fieldList: [
            {
                id: 'id',
                apiID: '',
                label: 'Licence No',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'application-name',
                apiID: '',
                label: 'Licence Name',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'application-businessStatus',
                apiID: '',
                label: 'Status',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'start-date',
                apiID: '',
                label: 'Start Date',
                type: 'text',
                rule: { required: true },
                span: 4
            },

            {
                id: 'expiry-date',
                apiID: '',
                label: 'Expiry Date',
                type: 'text',
                rule: { required: true },
                span: 4
            }
        ]
    }
];

export const SUMMARY_AEL = [
    {
        sectionID: 'summary',
        sectionName: 'Application Summary',
        fieldList: [
            {
                id: 'application-name',
                apiID: '',
                label: 'Application Name',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'title',
                apiID: 'Title',
                label: 'Title',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'status',
                apiID: '',
                label: 'Status',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'submission-date',
                apiID: '',
                label: 'Date of submission',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'id',
                apiID: '',
                label: 'IMDA Application No.',
                type: 'text',
                rule: { required: true },
                span: 4
            },
            {
                id: 'gbl-id',
                apiID: '',
                label: 'GBL Application No.',
                type: 'text',
                rule: { required: true },
                span: 4
            }
        ]
    }
];

export default SUMMARY;
